<template>
  <div class="vat">
    <div class="input-container">
      <span class="headline">VAT:</span>
      <div class="vat-input-container">
        <input
          v-model="vatId"
          v-bind:style="{ 'border-color': this.$store.state.vatValid }"
          class="input"
          type="text"
          v-on:input="updateVatId"
        />
        <!-- // value="GB984531981" -->
        <span class="button-container">
          <span v-if="this.vatCheckRunning" class="loading">
            <font-awesome-icon icon="circle-notch" class="fa-spin" />
            <span>loading</span>
          </span>
          <button
            v-if="!this.vatCheckRunning"
            v-on:click="validateVat()"
            class="validate-vat-button"
          >
            <span>check VAT</span>
          </button>
        </span>
      </div>
    </div>

    <div
      v-if="vatCheckExecuted"
      v-bind:style="{ color: vatErrorColor, 'border-color': vatErrorColor }"
      class="error-container"
    >
      <div v-if="vatErrorFok == 'A' &&
                    vatErrorSok == 'A' &&
                    vatErrorPok == 'A' &&
                    vatErrorCok == 'A'
                  ">
        <span class="error-headline">VAT VALIDATION ACCEPTED</span>
      </div>
      <div v-else>
        <span class="error-headline">VAT VALIDATION ERROR:</span>
        <div class="error-message-container">
          <div class="error-left" v-bind:style="{ color: vatErrorColor }">
            <span v-if="vatErrorMessage"
              >Please double check your address which is <br />registered at the
              authorities for your VAT number.</span
            >
            <br />
            <br />
            <span>
              <span class="check-item-title">COMPANY NAME:</span>
              <span>{{ vatErrorFok }}</span> <br />
              <span class="check-item-title">STREET NAME:</span>
              <span>{{ vatErrorSok }}</span> <br />
              <span class="check-item-title">ZIP-CODE:</span>
              <span>{{ vatErrorPok }}</span> <br />
              <span class="check-item-title">CITY:</span>
              <span>{{ vatErrorCok }}</span> <br />
            </span>
          </div>
          <div class="error-right">
            <span>A = data is correct</span> <br />
            <span>B = does not match</span> <br />
            <span>C = not requested</span> <br />
            <span>D = not reported by the EU Member State</span> <br />
            <span>
              F = ERROR - Service at the moment not available. Please try in two
              hours again.
            </span>
          </div>
        </div>
        <br />
        <div>
          <span>
            Important notice: <br />Please check the spelling of the VAT number
            you have entered. Please use the following website for this purpose:
          </span>
          <a target="_blank" href="https://vat-search.com/search/">
            https://vat-search.com/search/
          </a>
          <span> or </span>
          <a target="_blank" href="https://vat-search.com/">
            https://vat-search.com/
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vat-view",
  props: {
    title: String,
  },
  data() {
    return {
      vatCheckExecuted: false,
      vatErrorMessage: false,
      vatErrorColor: "green",
      vatErrorFok: "",
      vatErrorSok: "",
      vatErrorPok: "",
      vatErrorCok: "",
      vatCheckRunning: false,
      vatId: "",
    };
  },
  components: {},
  computed: {},
  async mounted() {
    // this.$store.commit("assignVatId", "GB984531981");
    if (this.$router.currentRoute.name.includes("subscription")) {
      await this.$store.dispatch("getSubscriptionCustomer");
      this.vatId = this.$store.state.customerData.vatId;
    }
  },
  methods: {
    async updateVatId(e) {
      await this.$store.commit("assignVatCheckSuccessfull", false);
      this.vatCheckExecuted = false;
      this.$store.commit("assignVatId", e.target.value);
    },
    async validateVat() {
      this.vatCheckRunning = true;
      this.vatCheckExecuted = false;
      await this.$store.dispatch("getVatValidation");
      this.vatCheckRunning = false;
      if (
        (this.$store.state.customerData.vatResult.cok == "A" ||
          this.$store.state.customerData.vatResult.cok == "D") &&
        (this.$store.state.customerData.vatResult.fok == "A" ||
          this.$store.state.customerData.vatResult.fok == "D") &&
        (this.$store.state.customerData.vatResult.pok == "A" ||
          this.$store.state.customerData.vatResult.pok == "D") &&
        (this.$store.state.customerData.vatResult.sok == "A" ||
          this.$store.state.customerData.vatResult.sok == "D")
      ) {
        this.vatErrorColor = "green";
        this.vatErrorMessage = false;
        this.vatCheckExecuted = true;
        this.$store.commit("assignVatCheckSuccessfull", true);
        this.$store.commit("assignVatValid", "#e7e7e7");
        this.$store.commit("assignCompanyValid", "#e7e7e7");
        this.$store.commit("assignStreetValid", "#e7e7e7");
        this.$store.commit("assignHouseNumberValid", "#e7e7e7");
        this.$store.commit("assignZipValid", "#e7e7e7");
        this.$store.commit("assignCityValid", "#e7e7e7");
      } else {
        this.vatErrorColor = "red";
        this.vatErrorMessage = true;
        this.vatCheckExecuted = true;

        if (
          this.$store.state.customerData.vatResult.fok != "A" &&
          this.$store.state.customerData.vatResult.fok != "D"
        ) {
          this.$store.commit("assignCompanyValid", "red");
        } else {
          this.$store.commit("assignCompanyValid", "#e7e7e7");
        }
        if (
          this.$store.state.customerData.vatResult.sok != "A" &&
          this.$store.state.customerData.vatResult.sok != "D"
        ) {
          this.$store.commit("assignStreetValid", "red");
          this.$store.commit("assignHouseNumberValid", "red");
        } else {
          this.$store.commit("assignStreetValid", "#e7e7e7");
          this.$store.commit("assignHouseNumberValid", "#e7e7e7");
        }
        if (
          this.$store.state.customerData.vatResult.pok != "A" &&
          this.$store.state.customerData.vatResult.pok != "D"
        ) {
          this.$store.commit("assignZipValid", "red");
        } else {
          this.$store.commit("assignZipValid", "#e7e7e7");
        }
        if (
          this.$store.state.customerData.vatResult.cok != "A" &&
          this.$store.state.customerData.vatResult.cok != "D"
        ) {
          this.$store.commit("assignCityValid", "red");
        } else {
          this.$store.commit("assignCityValid", "#e7e7e7");
        }
      }
      this.vatErrorFok = this.$store.state.customerData.vatResult.fok;
      this.vatErrorSok = this.$store.state.customerData.vatResult.sok;
      this.vatErrorPok = this.$store.state.customerData.vatResult.pok;
      this.vatErrorCok = this.$store.state.customerData.vatResult.cok;
    },
  },
};
</script>

<style scoped>
.vat {
  width: 100%;
  height: 100%;
  z-index: 99;
}

.vat .input-container {
  position: relative;
}
.vat .input-container input {
  padding-right: 95px;
}

.error-container {
  border: 1px solid;
  margin-top: 20px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 3px;
  font-size: 11px;
}
.error-container .error-headline {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  padding-top: 10px;
}

.error-message-container {
  height: 100%;
  display: flex;
}

.vat-input-container {
  position: relative;
}

.button-container {
  position: absolute;
  bottom: 0;
  right: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}

.validate-vat-button:hover {
  background-color: #fdd86a;
}

.validate-vat-button {
  cursor: pointer;
  background-color: #ffc20f;
  border: 1px solid #ffc20f;
  border-radius: 3px;
  color: white;
  outline: none;
}

.loading span {
  font-size: 15px;
  margin-left: 5px;
}
.loading {
  position: absolute;
  height: 100%;
  bottom: 0;
  right: 9px;
  color: grey;
  border-radius: 3px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.check-item-title {
  width: 150px;
  display: flex;
  float: left;
}

.error-right {
  width: 45%;
  float: right;
  padding-left: 10px;
  color: black;
  padding-top: 10px;
}
.error-left {
  width: 55%;
  border-right: 1px solid black;
  float: left;
}
</style>
